import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=67c94ec4"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c94ec4')) {
      api.createRecord('67c94ec4', component.options)
    } else {
      api.reload('67c94ec4', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=67c94ec4", function () {
      api.rerender('67c94ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Group.vue"
export default component.exports